module.exports = __webpack_public_path__ + "67e0ef1b750ac0d7c300a884b364350e.svg";